export const Config = {
  basePath: 'http://api.zoloft.noi.top',
  // basePath: 'http://127.0.0.1:5020',
  version: '3.4.0',
};
